import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';
import { natCerfConst } from 'modules/national-certificate';

import { ITests } from '../models';

export const getTests = (subjectSlug?: string) => async () => {
  const { data } = await $apiV2.get<{ data: ITests[] }>('/nat-certificate/tests?language_id=1&year_id=2025', {
    params: { subject_slug: subjectSlug }
  });

  return { tests: data.data };
};

export const useTests = ({ subjectSlug }: { subjectSlug?: string }) => {
  const { data, ...args } = useQuery({
    queryKey: [natCerfConst.queryKeys.NATIONAL_CERTIFICATE_TESTS, subjectSlug],
    queryFn: getTests(subjectSlug),
    refetchOnMount: true
  });

  return { ...data, ...args };
};
